import { useEffect, useState } from "react";
import { Reveal, SectionHead } from "./Reveal";
import { GALLERY } from "../lib/data";
import { useLang } from "../lib/i18n";
import { api, fileUrl } from "../lib/api";

export default function Gallery() {
  const { t } = useLang();
  const [real, setReal] = useState([]);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setReal(data)).catch(() => {});
  }, []);

  /* Real uploaded work photos come first; stock images fill the rest of the grid. */
  const items = [
    ...real.map((f, i) => ({ key: f.id, src: fileUrl(f.id), span: GALLERY[i % GALLERY.length].span, tag: t.gallery.realTag })),
    ...GALLERY.slice(real.length).map((g, i) => ({ key: g.src, src: g.src, span: g.span, tag: t.gallery.tags[real.length + i] })),
  ];

  return (
    <section id="gallery" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead tag={t.gallery.tag} title={t.gallery.title} sub={t.gallery.sub} />

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] lg:auto-rows-[230px] gap-4 mt-14">
          {items.map((g, i) => (
            <Reveal key={g.key} delay={0.05 * (i % 4)} className={g.span}>
              <figure
                data-testid={`gallery-item-${i + 1}`}
                className="group relative h-full w-full overflow-hidden rounded-2xl border border-white/10"
              >
                <img
                  src={g.src}
                  alt={g.tag}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1300ms]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-500" />
                <figcaption className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block rounded-full border border-white/15 bg-ink/70 backdrop-blur px-3.5 py-1.5 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-white group-hover:text-gold group-hover:border-gold/50 transition-colors duration-300">
                    {g.tag}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
